export default {
	props: {
		group: { type: String, default: "product-listing" },
	},
}
